import React from 'react';
import { ReactComponent as MoneyIcon } from "../../assets/icon/money.svg";
import { ReactComponent as ProccessIcon } from "../../assets/icon/proses.svg";
import { ReactComponent as SuccessIcon } from "../../assets/icon/success.svg";

function StatusInfo({ detailInvoice }) {
    return (
        <div className="flex flex-row ">
            <div
                className={`sm:flex-1 flex py-3   flex-col items-center  justify-center gap-2`}
            >
                <div className="flex flex-row w-full items-center">
                    <div className="w-full h-[3px] gap-3" />
                    <div
                        className={`p-2  ${detailInvoice.status === "not_paid" ||
                            detailInvoice.status === "processing" ||
                            detailInvoice.status === "success" ||
                            detailInvoice.status === "pending" ||
                            detailInvoice.status === "paid"
                            ? "bg-[#FF9800]"
                            : detailInvoice.status === "cancel"
                                ? "bg-[#F44336]"
                                : detailInvoice.status === "refund"
                                    ? "bg-[#f4ae36]"
                                    : "bg-[#D8E7FF]"
                            } mx-2 rounded-md flex gap-2`}
                    >
                        <MoneyIcon className="w-5 h-5" fill={"#ffffff"} />
                        <span
                            className={`text-sm font-semibold text-darkColor line-clamp-1 sm:block hidden `}
                        >
                            Pembayaran
                        </span>
                    </div>
                    <div
                        className={`w-full h-[3px] gap-3 ${detailInvoice.status === "not_paid" ||
                            detailInvoice.status === "processing" ||
                            detailInvoice.status === "success" ||
                            detailInvoice.status === "pending" ||
                            detailInvoice.status === "paid"
                            ? "bg-[#FF9800]"
                            : detailInvoice.status === "cancel"
                                ? "bg-[#F44336]" : detailInvoice.status === "refund"
                                    ? "bg-[#f4ae36]"
                                    : "bg-[#D8E7FF]"
                            }`}
                    />
                </div>
            </div>
            <div
                className={`flex-1 flex py-3   flex-col items-center  justify-center gap-2`}
            >
                <div className="flex flex-row w-full items-center">
                    <div
                        className={`w-full h-[3px] gap-3  ${detailInvoice.status === "not_paid" ||
                            detailInvoice.status === "processing" ||
                            detailInvoice.status === "success" ||
                            detailInvoice.status === "pending" ||
                            detailInvoice.status === "paid"
                            ? "bg-[#FF9800]"
                            : detailInvoice.status === "cancel"
                                ? "bg-[#F44336]" : detailInvoice.status === "refund"
                                    ? "bg-[#f4ae36]"
                                    : "bg-[#D8E7FF]"
                            }`}
                    />
                    <div
                        className={`p-2 ${detailInvoice.status === "processing" ||
                            detailInvoice.status === "success" ||
                            detailInvoice.status === "pending" ||
                            detailInvoice.status === "paid"
                            ? "bg-[#2196F3]"
                            : detailInvoice.status === "cancel"
                                ? "bg-[#F44336]" : detailInvoice.status === "refund"
                                    ? "bg-[#f4ae36]"
                                    : "bg-[#D8E7FF]"
                            } mx-2 rounded-md flex gap-2`}
                    >
                        <ProccessIcon className="w-5 h-5" fill={"#ffffff"} />
                        <span
                            className={`text-sm font-semibold text-darkColor line-clamp-1 sm:block hidden `}
                        >
                            Proses
                        </span>
                    </div>
                    <div
                        className={`w-full h-[3px] gap-3 ${detailInvoice.status === "processing" ||
                            detailInvoice.status === "success" ||
                            detailInvoice.status === "pending" ||
                            detailInvoice.status === "paid"
                            ? "bg-[#2196F3]"
                            : detailInvoice.status === "cancel"
                                ? "bg-[#F44336]" : detailInvoice.status === "refund"
                                    ? "bg-[#f4ae36]"
                                    : "bg-[#D8E7FF]"
                            }`}
                    />
                </div>
            </div>
            <div
                className={`sm:flex-1 py-3   flex flex-col items-center  justify-center gap-2`}
            >
                <div className="flex flex-row w-full items-center">
                    <div
                        className={`flex-1 flex  h-[3px]  gap-3  ${detailInvoice.status === "processing" ||
                            detailInvoice.status === "success" ||
                            detailInvoice.status === "pending" ||
                            detailInvoice.status === "paid"
                            ? "bg-[#2196F3]"
                            : detailInvoice.status === "cancel"
                                ? "bg-[#F44336]" : detailInvoice.status === "refund"
                                    ? "bg-[#f4ae36]"
                                    : "bg-[#D8E7FF]"
                            }`}
                    />
                    <div
                        className={`p-2 flex-1 flex  ${detailInvoice.status === "success"
                            ? "bg-[#4CAF50]"
                            : detailInvoice.status === "cancel"
                                ? "bg-[#F44336]" : detailInvoice.status === "refund"
                                    ? "bg-[#f4ae36]"
                                    : "bg-[#D8E7FF]"
                            } mx-2 rounded-md flex gap-2 items-center `}
                    >
                        <SuccessIcon className="w-5 h-5" fill={"#ffffff"} />
                        <span
                            className={`text-sm sm:block hidden font-semibold text-darkColor sm:w-28 flex-1 `}
                        >
                            Pesanan Selesai
                        </span>
                    </div>
                    <div className="flex-1 flex h-[3px] gap-3" />
                </div>
            </div>
        </div>
    );
}

export default StatusInfo;
